import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { Capacitor } from '@capacitor/core';
import PendenciaDBService from '../database/pendencia-db.service';
import { map, Observable } from 'rxjs';
import { Pendencia } from '../models/pendencia';
import { Atividade, AtividadeHistorico } from '../models/atividade';

@Injectable({
  providedIn: 'root'
})
export class PendenciaService extends BaseService {
    override classname: string = 'PendenciaService';
    public override route: string = 'pendencia';
    public override database = Capacitor.isNativePlatform() ? new PendenciaDBService() : new PendenciaDBService();

    public override novo() {
        return {
            imagens: []
        }
    }

    public check(execucao: AtividadeHistorico, index: number): Observable<Pendencia>{
        return this.get(null, {atividade_id: execucao.atividade_id, atividade_historico: execucao.identificador, atividade_checklist: index, limit: 1});
    }

    public checkAll(atividade: Atividade): Observable<Pendencia[]>{
        return this.get(null, {atividade_id: atividade.id, status: 'P', limit: 0}).pipe(map((r) => r.data));
    }
}
